import { render, staticRenderFns } from "./SettingAccount.vue?vue&type=template&id=9828d8fe&"
import script from "./SettingAccount.vue?vue&type=script&lang=js&"
export * from "./SettingAccount.vue?vue&type=script&lang=js&"
import style0 from "./SettingAccount.vue?vue&type=style&index=0&id=9828d8fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports